import{NjcToast as u}from"../../toast.js";import"../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as e}from"../../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{customElement as m}from"../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";import g from"../../../../packages/web-components/src/components/toast/gator/base/toast.gator.scss.js";import v from"../../../../packages/web-components/src/tokens/primitive.tokens.scss.js";import d from"../../../../packages/web-components/src/tokens/semantic.tokens.scss.js";import"../../../icon-button/gator/icon-button.gator.js";import{unsafeCSS as r}from"../../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";var h=Object.getOwnPropertyDescriptor,b=(t,o,l,n)=>{for(var s=n>1?void 0:n?h(o,l):o,i=t.length-1,c;i>=0;i--)(c=t[i])&&(s=c(s)||s);return s};let a=class extends u{render(){return e`
            <div
                class="gator-toast ${this.variantClass}"
                role="${this.ariaRole}"
                aria-live="polite"
            >
                ${this.iconMarkup}

                <div class="gator-toast-content-container">
                    <div class="gator-toast-content">
                        <slot name="content">
                            <ngc-toast-title>${this.title}</ngc-toast-title>
                            <ngc-toast-subtitle>${this.subtitle}</ngc-toast-subtitle>
                        </slot>
                    </div>

                    ${this.actionsSlot}
                </div>

                ${this.dismissibleMarkup}
            </div>
        `}get ariaRole(){return this.sticky?"alertdialog":"alert"}get actionsSlot(){return this.querySelector('[slot="actions"]')?e`
            <div class="gator-toast-actions">
                <slot name="actions"></slot>
            </div>
        `:null}get variantClass(){switch(this.variant){case"info":return"gator-toast_info";case"warning":return"gator-toast_warning";case"error":return"gator-toast_error";case"success":return"gator-toast_success";case"inverse":return"gator-toast_inverse";default:return"gator-toast_info"}}get iconMarkup(){let t="info";switch(this.variant){case"info":t="info";break;case"warning":t="warning";break;case"error":t="restricted";break;case"success":t="check-circle";break;case"inverse":t="info";break}return e`
            <ngc-icon
                name="${t}"
                label="${this.statusIconLabel??t}"
            ></ngc-icon>
        `}get dismissibleMarkup(){return this.dismissible?e`
            <div class="gator-toast-dismiss-button">
                <ngc-icon-button
                    aria-label="${this.exitIconLabel}"
                    icon-name="exit"
                    size="medium"
                    @click=${this.handleDismiss}
                ></ngc-icon-button>
            </div>
        `:null}handleDismiss(){this.dispatchEvent(new CustomEvent("dismiss",{bubbles:!0,composed:!0}))}};a.styles=[r(g),r(v),r(d)];a=b([m("ngc-toast")],a);export{a as NgcToast};
